var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"p-8 bg-white"},[_c('activity-viewer',{attrs:{"page":1,"count":50,"requestGroupId":_vm.$route.params.groupId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }